import { apiGet } from '../client';
import type { Environment } from '../../constants';
import type { IListResponse, ITenantSummary } from '../../types';

export const getTenants = (environment: Environment): Promise<IListResponse<ITenantSummary>> =>
  apiGet<IListResponse<ITenantSummary>>(environment, '/tenants');
